import { ENDPOINTS } from './endpoints.constants';

export const UPLOAD_FILES_URL_KEY = 'uploadFileUrls';

export const uploadFileUrls = {
  upload: ENDPOINTS.Application.Media.Upload,
  remove: ENDPOINTS.Application.Media.Remove,
};

export const vendorUploadFileUrls = {
  upload: ENDPOINTS.VendorPortal.Media.Upload,
  remove: ENDPOINTS.VendorPortal.Media.Remove,
};

export const uploadFileUrlsValidation = {
  maxImageSize: 2 * 1024 * 1000,
  acceptedImageTypes: 'jpg,jpeg,png,webp',
  maxFileSize: 25 * 1024 * 1000,
  acceptedFileTypes: 'doc,docx,xls,xlsx,ppt,pptx,pdf,png,jpg,jpeg',
  newAcceptedFileTypes: 'doc,docx,xls,xlsx,ppt,pptx,pdf,png,jpg,jpeg,rar,zip',
  maxFilesNo: 10,
};
